import React from 'react'
import Carousel from './Carousel/Carousel'
import CoinsTable from './CoinsTable'
import HomeHeader from './HomeHeader'
export default function Home () {
  return (
    <div>
  
      <HomeHeader/>
    </div>
  )
}
